import { render, staticRenderFns } from "./LongStayAlertSettingEditor.vue?vue&type=template&id=1e501cf0&scoped=true&lang=pug"
import script from "./LongStayAlertSettingEditor.vue?vue&type=script&lang=ts"
export * from "./LongStayAlertSettingEditor.vue?vue&type=script&lang=ts"
import style0 from "./LongStayAlertSettingEditor.vue?vue&type=style&index=0&id=1e501cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e501cf0",
  null
  
)

export default component.exports